const headerMenuCollapsable = document.querySelector('.header-menu-collapsable');
if (headerMenuCollapsable) {
  headerMenuCollapsable.addEventListener('click', function() {
    const collapsableClasses = this.classList
    if (collapsableClasses.contains('open')) {
      collapsableClasses.remove('open')
    } else {
      collapsableClasses.add('open')
    }
    const menuClasses = document.querySelector('.header-menu-mobile').classList
    if (menuClasses.contains('visible')) {
      menuClasses.remove('visible')
    } else {
      menuClasses.add('visible')
    }
  })
}

const menuItems = document.querySelectorAll('.menu-item-title')
menuItems.forEach(item => {
  item.addEventListener('click', function(e) {
    const classes = this.parentNode.classList
    const menuItems = this.parentNode.parentNode.childNodes;
    if (classes.contains('visible')) {
      classes.remove('visible')
    } else {
      menuItems.forEach(item => {
        if (item.classList.contains("visible")) {
          item.classList.remove("visible");
        }
      });
      classes.add('visible')
    }
  })
})


const menuLargeItems = document.querySelectorAll('.header-menu li');


menuLargeItems.forEach(item => {
    let timer;
    if (item.classList.contains('search-icon-container')) {
        return;
    }
    item.addEventListener('mouseenter', () => {
        clearTimeout(timer);
        timer = setTimeout(() => {
        item.querySelector('.header-submenu').style.display = 'flex';
        }, 700);
    });

    item.addEventListener('mouseleave', () => {
        clearTimeout(timer);
        timer = setTimeout(() => {
        item.querySelector('.header-submenu').style.display = 'none';
        }, 700);
    });
});


let lastScrollY = window.scrollY;
let navbar = document.querySelector('.layout-top');
let isMobile = window.innerWidth <= 600;
let hideThreshold = 100;
let showThreshold = isMobile ? 10 : 100;
let lastHidePosition = 0;
let lastShowPosition = 0;
let navbarHidden = false;

window.addEventListener('scroll', () => {
  let currentScrollY = window.scrollY;

  if (currentScrollY === 0) {
    navbar.classList.remove('layout-top-sticky-show');
    navbar.classList.remove('layout-top-sticky-animate');
    navbar.classList.remove('layout-top-sticky');
    navbarHidden = false;
    lastHidePosition = 0;
    lastShowPosition = 0;
    lastScrollY = 0;
    return;
  }

  if (currentScrollY > lastScrollY) {
    if (currentScrollY - lastHidePosition > hideThreshold) {
      navbar.classList.add('layout-top-sticky');
      navbar.classList.remove('layout-top-sticky-show');
      const mobileMenu = document.querySelector('#mobile-menu');
      if (mobileMenu) {
        mobileMenu.classList.remove('visible');
        mobileMenu.hidePopover();
      }
      document.querySelector('.header-menu-collapsable').classList.remove('open');

      navbarHidden = true;
      lastShowPosition = currentScrollY;
    }
  } else {
    if (lastShowPosition - currentScrollY > showThreshold) {
      navbar.classList.add('layout-top-sticky-animate');
      navbar.classList.add('layout-top-sticky-show');
      navbarHidden = false;
      lastHidePosition = currentScrollY;
    }
  }

  lastScrollY = currentScrollY;
});
